type VideoComponentProps = {
  readonly src: string;
  readonly width: string;
  readonly height: string;
  readonly minHeight: string;
};

const VideoComponent = ({ src, width, height, minHeight }: VideoComponentProps) => {
  return (
    <div className="my-[100px] w-full">
      <iframe
        className="aspect-video"
        style={{ minHeight }}
        width={width}
        height={height}
        src={src}
        title="新製品 コピック アクレア】もっと自由に、色も素材も楽しめる。新しいコピック。"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VideoComponent;